import { render, staticRenderFns } from "./open-receivables.vue?vue&type=template&id=7bab1890&"
import script from "./open-receivables.vue?vue&type=script&lang=js&"
export * from "./open-receivables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports